import AppWrapper from "../../../components/cm/AppWrapper";
import SideBarMain from "../../../components/cm/SideBarMain";
import ViewDocuments from "../../../components/modules/Documents/ViewDocuments";

export default function ViewDocumentDetail() {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <div className="h-[calc(100vh-5rem)] overflow-y-auto bg-white">
        <ViewDocuments customBaseDetailPath="/client-detail/" />
      </div>
    </AppWrapper.WithSidebar>
  );
}
